import Vue from "vue";
import VueI18n from "vue-i18n";
import App from "./App.vue";
import VueRouter from "vue-router";
import { languages, defaultLocale } from "./i18n/index.js";
import router from "./router/index";
import "./assets/tailwind.css";
import "./assets/rtl.css";
import "@zidsa/ui/styles/global.css";
import VueLuxon from "vue-luxon";
import VueLodash from "vue-lodash";
import orderBy from "lodash/orderBy";
import vmodal from "vue-js-modal";
import VueToast from "vue-toast-notification";
import "vue-toast-notification/dist/theme-sugar.css";
import store from "./store/index";
import Vuelidate from "vuelidate";

Vue.use(VueToast);
Vue.use(VueLodash, { name: "Lodash", lodash: { orderBy } });
Vue.use(VueI18n);
const messages = Object.assign(languages);
export const i18n = new VueI18n({
  locale: defaultLocale,
  messages,
});

// @ts-ignore:next-line
Vue.use(VueRouter);
Vue.use(VueLuxon, {
  input: { zone: "utc" },
  output: { zone: "utc" },
});
Vue.use(vmodal);
Vue.use(Vuelidate);

new Vue({
  router,
  i18n,
  store,
  render: (h) => h(App),
}).$mount("#app");
